import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";

const GoogleMapsOrderStatus = ({ restaurantAddress, userAddress }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDDq_Z5B-HLaZH9Wsans0cbSSZ28y3GkEs",
    libraries: ["places"],
  });

  const [directionsResponse, setDirectionsResponse] = useState(null);

  useEffect(() => {
    if (isLoaded && restaurantAddress && userAddress) {
      calculateRoute();
    }
  }, [isLoaded, restaurantAddress, userAddress]);

  const calculateRoute = async () => {
    try {
      const directionsService = new window.google.maps.DirectionsService();
      const result = await directionsService.route({
        origin: restaurantAddress,
        destination: userAddress,
        travelMode: window.google.maps.TravelMode.DRIVING,
      });

      if (result?.routes.length > 0) {
        setDirectionsResponse(result);
      }
    } catch (error) {
      console.error("Error fetching route:", error);
    }
  };

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading maps...</p>;

  return (
    <div className="relative w-[90%] mx-auto mb-10 h-[300px] mt-4">
      <GoogleMap
        center={{ lat: 40.7128, lng: -74.006 }} // Default center (adjust as needed)
        zoom={13}
        mapContainerStyle={{ width: "100%", height: "100%" }}
        options={{
          zoomControl: true,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        {/* Show route if available */}
        {directionsResponse && <DirectionsRenderer directions={directionsResponse} />}

        {/* Markers for Restaurant and User Address */}
        <Marker position={restaurantAddress} label="Restaurant" />
        <Marker position={userAddress} label="You" />
      </GoogleMap>
    </div>
  );
};

export default GoogleMapsOrderStatus;
